export const MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX = 'MAP_SETTINGS_COLUMNS_FILTER';

export const MAP_SETTINGS_COLUMNS_FILTER_CLEAR_FILTERS = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/CLEAR_FILTERS`;

export const MAP_SETTINGS_COLUMNS_FILTER_REMOVE_FILTER_VALUES = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/REMOVE_FILTER_VALUES`;

export const MAP_SETTINGS_COLUMNS_FILTER_SET_TEXT = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/SET_TEXT`;
export const MAP_SETTINGS_COLUMNS_FILTER_CHANGE_TEXT_CONJUNCTION = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/CHANGE_TEXT_CONJUNCTION`;

export const MAP_SETTINGS_COLUMNS_FILTER_SET_GROUP = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/SET_GROUP`;

export const MAP_SETTINGS_COLUMNS_FILTER_SET_NUMBER = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/SET_NUMBER`;

export const MAP_SETTINGS_COLUMNS_FILTER_SET_INCLUDE_NOT_A_DATE = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/SET_INCLUDE_NOT_A_DATE`;
export const MAP_SETTINGS_COLUMNS_FILTER_SET_DATE_FROM = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/SET_DATE_FROM`;
export const MAP_SETTINGS_COLUMNS_FILTER_SET_DATE_TO = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/SET_DATE_TO`;

export const MAP_SETTINGS_COLUMNS_FILTER_SET_ATTRIBUTE = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/SET_ATTRIBUTE`;
export const MAP_SETTINGS_COLUMNS_FILTER_CHANGE_ATTRIBUTE_CONJUNCTION = `${MAP_SETTINGS_COLUMNS_FILTER_ACTION_PREFIX}/CHANGE_ATTRIBUTE_CONJUNCTION`;
